import IframeBridge from 'IframeBridge';
import dayjs from 'dayjs';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { findImage } from 'utils/Utils';

const SuccessPage = () => {
  const { t, i18n } = useTranslation();

  const { paymentState } = usePaymentState();
  const returnType = window.sessionStorage.getItem('returnType');

  useEffect(() => {
    if (returnType === 'DIRECT') {
      closeProcess();
    }
  }, [returnType]);

  const closeProcess = () => {
    const returnObject = {};
    if (paymentState.billKey === '' || paymentState.billKey === undefined) {
      Object.assign(returnObject, {
        resultStatus: 'SUCCESS',
        resultCode: paymentState.resultCode,
        resultMessage: paymentState.resultMessage,
        tid: paymentState.tid,
        orderId: paymentState.orderId,
        mallReserved: paymentState.mallReserved,
        returnUrl: paymentState.returnUrl,
        schemeGroup: paymentState.schemeGroup,
        schemeCode: paymentState.schemeCode,
      });
    } else {
      Object.assign(returnObject, {
        resultStatus: 'SUCCESS',
        resultCode: paymentState.resultCode,
        resultMessage: paymentState.resultMessage,
        tid: paymentState.tid,
        orderId: paymentState.orderId,
        mallReserved: paymentState.mallReserved,
        returnUrl: paymentState.returnUrl,
        billKey: paymentState.billKey,
        schemeGroup: paymentState.schemeGroup,
        schemeCode: paymentState.schemeCode,
      });
    }

    if (isMobile) {
      const url = new URL(paymentState.returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('resultStatus', 'SUCCESS');
      params.set(
        'resultCode',
        paymentState.resultCode ? paymentState.resultCode : '',
      );
      params.set(
        'resultMessage',
        paymentState.resultMessage ? paymentState.resultMessage : '',
      );
      params.set('tid', paymentState.tid);
      params.set('orderId', paymentState.orderId);
      params.set(
        'mallReserved',
        paymentState?.mallReserved ? paymentState.mallReserved : '',
      );
      params.set(
        'schemeGroup',
        paymentState?.schemeGroup ? paymentState.schemeGroup : '',
      );
      params.set(
        'schemeCode',
        paymentState?.schemeCode ? paymentState.schemeCode : '',
      );
      if (paymentState.billKey) {
        params.set('billKey', paymentState.billKey);
      }
      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  const handleAllClose = e => {
    e.preventDefault();
    closeProcess();
  };

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('success.png')} />
          </div>
          <div className="title">{t('payment_success')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('payment_success_completed')}
          </div>
          <div className="info-box">
            <div
              className={i18n.language === 'en' ? 'each-sec' : 'each-sec-tight'}
            >
              <div>{t('total_amount')}</div>
              <div>
                {`${Number(paymentState.requestAmount).toLocaleString(
                  'en-US',
                )} ${
                  paymentState.requestCurrency === 'KRW'
                    ? t('KRW')
                    : paymentState.requestCurrency
                }`}
              </div>
            </div>
            <div
              className={i18n.language === 'en' ? 'each-sec' : 'each-sec-tight'}
            >
              <div>{t('order_number')}</div>
              <div>{paymentState.orderId}</div>
            </div>
            <div
              className={i18n.language === 'en' ? 'each-sec' : 'each-sec-tight'}
            >
              <div>{t('transaction_date')}</div>
              <div>
                {dayjs(paymentState.reqDate).format('YYYY.MM.DD HH:mm:ss')}
              </div>
            </div>
            <div
              className={i18n.language === 'en' ? 'each-sec' : 'each-sec-tight'}
            >
              <div>{t('descriptor')}</div>
              <div>{paymentState.descriptor}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="completed-btn">
        <div className="box confirmBox">
          <button className="all-close" onClick={handleAllClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </>
  );
};

export default SuccessPage;
